import { StyleDeclarationValue, css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { TagsViewModel } from '../../../extViewmodels';
import { useErrorMessages, useUserSession } from '../../../models/hooks/appStateHooks';
import { CreateGhostCalendarSuggestionViewModel } from '../../../viewmodels/AdminViewModels';
import { Checkbox } from '../../../web/components/Checkbox';
import { LoadingSpinner } from '../../../web/components/LoadingSpinner';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	createSuggestion: CreateGhostCalendarSuggestionViewModel;
	styles?: StyleDeclarationValue[];
}

export const GhostCalendarTags: React.FC<IProps> = observer(props => {
	const { className, createSuggestion, styles = [] } = props;
	const [tagOptions, setTagOptions] = React.useState<string[]>([]);
	const [loading, setLoading] = React.useState(false);
	const userSession = useUserSession();
	const errorMessages = useErrorMessages();
	const tagsVm = React.useRef(new TagsViewModel(userSession)).current;

	React.useEffect(() => {
		setLoading(true);
		tagsVm
			.getDefaultTagsByIndustry(createSuggestion?.industries?.length === 1 ? createSuggestion.industries[0] : '')
			.then(result => {
				setTagOptions(result);
				setLoading(false);
			})
			.catch(err => {
				errorMessages.pushApiError(err);
				setLoading(false);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onTagClick = (t: string) => () => {
		const index = createSuggestion?.tags.indexOf(t);
		const newTags = [...(createSuggestion?.tags || [])];
		if (index >= 0) {
			newTags.splice(index, 1);
		} else {
			newTags.push(t);
		}
		createSuggestion.tags = newTags;
	};

	const renderTags = () => {
		return tagOptions.map((tag, i) => {
			const isSelected = createSuggestion?.tags?.includes(tag);
			return (
				<div className={css(styleSheet.flex, styleSheet.itemContainer)} key={`${tag}-${i}`}>
					<Checkbox checked={isSelected} id={`${tag}-option-${i}`} onChange={onTagClick(tag)} />
					<button className={css(styleSheet.contentContainer)} onClick={onTagClick(tag)}>
						<span
							className={`tag ${css(
								styleSheet.pill,
								isSelected ? styleSheet.pillSelected : styleSheet.pillUnselected
							)}`}
						>
							{tag}
						</span>
					</button>
				</div>
			);
		});
	};

	return (
		<div className={`${css(styleSheet.container, ...styles)} component-class ${className || ''}`}>
			<div className={css(styleSheet.content)}>
				<div className={css(styleSheet.title)}>Select Recipients to Send (optional):</div>
				<div className={css(styleSheet.text)}>Popular Tags</div>
				{loading ? <LoadingSpinner /> : renderTags()}
			</div>
			<div className={css(styleSheet.textLight)}>
				If the client doesn&apos;t have matching tags, we&apos;ll ask them to choose their own tags instead.
			</div>
		</div>
	);
});
